// import { Contact11Component } from "../../../components/borrowSystem/Contact/Contact11Component";
import { AttatchFileForContactComponent } from "../../../components/borrowSystem/Contact/AttatchFileForContactComponent";
import { HeadTitle } from "../../../components/share/HeadTitle";
import { Footer } from "../../../components/share/Footer";
import { NavbarBorrowSystem } from "../../../components/share/NavbarBorrowSystem";
export function AttatchFileForContactContainer() {
  const titleName = "แนบเอกสาร"; //ใส่ชื่อtitle ตรงนี้
  return (
    <div className="page-container bg-landing">
      <NavbarBorrowSystem />
      <HeadTitle title={titleName} />
      <AttatchFileForContactComponent />
      <Footer />
    </div>
  );
}
